import React from 'react';
import { SelectInput, useQuery } from 'react-admin';
import { useFormState } from 'react-final-form';

/**
 * Machine # picker for the Phlebotomy tab.
 *
 * Offers the active plasmapheresis machines from the instrument register -
 * view_instruments rows whose category code is one of MACHINE_CODES - instead
 * of free text. The stored value is the instrument's ins_id, which is what
 * pcs_num has always held (e.g. "A1001"); the label shown is the instrument's
 * name.
 */
const MACHINE_CODES = ['Aurora', 'NexSys', 'Rika', 'PCS2'];

const MachineInput = ({ validate, disabled }) => {
    const { values } = useFormState({ subscription: { values: true } });

    const { data } = useQuery({
        type: 'getList',
        resource: 'machinelist',
        payload: {
            filter: { code: MACHINE_CODES },
            sort: { field: 'name', order: 'ASC' },
            pagination: { page: 1, perPage: 200 },
        },
    });

    const choices = (data || []).slice();

    // Two machines of the same model would otherwise be indistinguishable in
    // the list, so the unit id is appended whenever a name repeats.
    const counts = {};
    choices.forEach(choice => {
        counts[choice.name] = (counts[choice.name] || 0) + 1;
    });
    const optionText = choice =>
        counts[choice.name] > 1
            ? choice.name + ' (' + choice.ins_id + ')'
            : choice.name;

    // A record saved before the picker existed can hold a machine # that is
    // not in the register any more; keep showing it rather than blanking a
    // historical value.
    const current = values.pcs_num;
    if (current && !choices.find(choice => String(choice.id) === String(current))) {
        choices.push({ id: current, ins_id: current, name: String(current) });
    }

    return (
        <SelectInput
            source="pcs_num"
            label=""
            choices={choices}
            optionText={optionText}
            optionValue="id"
            validate={validate}
            disabled={disabled}
            allowEmpty={!validate}
        />
    );
};

export default MachineInput;
